const LangAddCard = {
	"addCard._title": ["ADD A CARD", "THÊM THẺ MỚI"],
	"addCard.form.button._addCard": ["Add Card", "Nhập"],
}

export default LangAddCard
